/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Gaudy_Ostrich_WishInputs */

const fr_bold_gaudy_ostrich_wish = /** @type {(inputs: Bold_Gaudy_Ostrich_WishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vues`)
};

/**

* @param {Bold_Gaudy_Ostrich_WishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bold_gaudy_ostrich_wish = /** @type {((inputs?: Bold_Gaudy_Ostrich_WishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Gaudy_Ostrich_WishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bold_gaudy_ostrich_wish(inputs)
});